import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {isNil, reject, uniq} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {
  getVehicleMakes,
  getCustomTenantCatalogue,
  getVehicleSeriesDefinitionList,
  selectVehicleSeriesDefinitionList,
  useThunkDispatch,
} from '@dms/teas';

import {useBoolean} from 'shared/web';

import {VehicleSeriesDefinitionList} from './components/VehicleSeriesDefinitionList';
import {vehicleSeriesDefinitionCommonActions} from './utils/utils';

export function VehicleSeriesDefinition() {
  const dispatch = useThunkDispatch();
  const vehicleSeriesDefinitionList = useSelector(selectVehicleSeriesDefinitionList);

  const [isLoading, startLoading, stopLoading] = useBoolean(false);

  useEffect(
    function loadSeriesDefinitions() {
      startLoading();

      const loadSupportingData = (definitionList: Array<{vehicleType?: string | null}>) => {
        const vehicleTypes = reject(
          isNil,
          uniq(
            definitionList
              .map(({vehicleType}) => vehicleType)
              .filter((type) => typeof type === 'string')
          )
        );

        Promise.all([
          dispatch(getCustomTenantCatalogue.action({})),
          ...vehicleSeriesDefinitionCommonActions.map((action) => dispatch(action)),
          ...vehicleTypes.map((vehicleType) => dispatch(getVehicleMakes.action({vehicleType}))),
        ]).finally(() => {
          stopLoading();
        });
      };

      if (vehicleSeriesDefinitionList.length > 0) {
        loadSupportingData(vehicleSeriesDefinitionList);
      } else {
        dispatch(getVehicleSeriesDefinitionList.action({})).unwrap().then(loadSupportingData);
      }
    },
    [dispatch, startLoading, stopLoading] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );

  return (
    <SettingsTemplate
      isLoading={isLoading}
      header={{title: i18n.t('page.salesSettings.labels.vehicleSeriesDefinitionTitle')}}
      data-testid={testIds.settings.vehicleSeriesDefinition('modal')}
      description={i18n.t('page.salesSettings.labels.vehicleSeriesDefinitionDescription')}
    >
      <VehicleSeriesDefinitionList />
    </SettingsTemplate>
  );
}
